/**
 * File video-page-scripts.js.
 *
 * Unmute Fullscreen Video Page audio after the intro overlay, or on load
 * when there is no intro. Keeps the muted autoplay attribute so visual
 * playback is not blocked; browsers may still require a click to allow sound.
 *
 */

(function ($) {
  var $video = $('.video-page__media');
  if (!$video.length) {
    return;
  }

  var video = $video.get(0);
  var unmuted = false;
  var started = false;
  var unlockBound = false;
  var fallbackTimer = 0;

  function bindUnlock() {
    if (unlockBound) {
      return;
    }
    unlockBound = true;
    $(document).on('click.videoPageAudio touchstart.videoPageAudio', tryUnmute);
  }

  function unbindUnlock() {
    if (!unlockBound) {
      return;
    }
    unlockBound = false;
    $(document).off('click.videoPageAudio touchstart.videoPageAudio', tryUnmute);
  }

  function tryUnmute() {
    if (unmuted) {
      return;
    }

    video.muted = false;
    var playPromise = video.play();

    function finishIfAudible() {
      if (video.muted) {
        bindUnlock();
        return;
      }
      unmuted = true;
      unbindUnlock();
    }

    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.then(finishIfAudible).catch(function () {
        video.muted = true;
        video.play();
        bindUnlock();
      });
      return;
    }

    finishIfAudible();
  }

  function unmuteNow(restart) {
    if (started) {
      return;
    }
    started = true;
    if (fallbackTimer) {
      window.clearTimeout(fallbackTimer);
      fallbackTimer = 0;
    }
    if (restart) {
      try {
        video.currentTime = 0;
      } catch (e) {
        // Ignore if the media is not seekable yet.
      }
    }
    tryUnmute();
  }

  var waitIntro = $video.attr('data-wait-intro') === 'true';
  var $intro = $('.animation_parent');

  if (!waitIntro || !$intro.length) {
    unmuteNow(false);
    return;
  }

  $intro.on('animationend webkitAnimationEnd', function (event) {
    var name = event.originalEvent && event.originalEvent.animationName;
    if (event.target !== this) {
      return;
    }
    if (name && name !== 'single') {
      return;
    }
    unmuteNow(true);
  });

  // Parent overlay: 3.25s delay + 2s fade. Backup if animationend never fires.
  fallbackTimer = window.setTimeout(function () {
    unmuteNow(true);
  }, 6000);
})(jQuery);
